<template>
    <div class="relative">
        <div
            class="w-full rounded-[6px] border-2 border-dashed p-6"
            :class="
                isDragging
                    ? 'border-topol-blue-600 bg-gray-50'
                    : 'border-topol-blue-600'
            "
            @dragleave="onDragLeave"
            @dragover.prevent
            @drop.prevent="onDrop"
            @dragenter="onDragEnter"
        >
            <div :class="isDragging ? 'pointer-events-none' : ''">
                <component
                    :is="uploaded ? DocumentTextIcon : CloudArrowUpIcon"
                    class="mx-auto h-14 w-14 cursor-pointer text-topol-blue-600"
                    @click="clickToUpload"
                />

                <p class="text-center text-xs text-gray-500">{{ fileName }}</p>

                <p class="mt-2 text-center text-base text-gray-600">
                    <span
                        class="cursor-pointer underline"
                        @click="clickToUpload"
                        >Click to upload</span
                    >
                    or drag and drop
                </p>
                <p class="text-center text-xs text-gray-500">
                    Maximum file size: 5 MB
                </p>
                <p class="text-center text-xs text-gray-500">
                    Supported file type: JSON
                </p>
            </div>
        </div>

        <div class="mt-2 text-sm text-gray-600">
            <p>
                Click to download a
                <button class="underline" type="button" @click="downloadJson">
                    JSON example
                </button>
            </p>
        </div>

        <input
            id="json-upload"
            :key="key"
            ref="jsonInput"
            type="file"
            class="hidden"
            accept=".json"
            @change="onFileAdded"
        />
    </div>
</template>

<script setup lang="ts">
import { CloudArrowUpIcon, DocumentTextIcon } from '@heroicons/vue/24/solid';

const emit = defineEmits(['file-added', 'download-json']);

const clickToUpload = () => {
    jsonInput.value?.click();
};

const jsonInput = ref<HTMLInputElement | null>(null);
const key = ref<number>(0);

const uploaded = ref<boolean>(false);
const fileName = ref<string>('');
const isDragging = ref<boolean>(false);

const onFileAdded = async (e: Event) => {
    handleFile((e.target as HTMLInputElement)?.files?.[0]);
};

const onDrop = (e: DragEvent) => {
    isDragging.value = false;
    const file = e.dataTransfer?.files?.[0];
    if (file) handleFile(file);
};

const onDragEnter = () => {
    isDragging.value = true;
};

const onDragLeave = () => {
    isDragging.value = false;
};

const downloadJson = () => {
    const link = document.createElement('a');
    link.href =
        import.meta.env.VITE_AWS_S3_CLOUDFRONT_URL +
        '/assets/template-example.zip';
    link.download = 'template-example.json';
    link.click();
};

const handleFile = (file?: File) => {
    if (!file || file.type !== 'application/json') return;

    const reader = new FileReader();
    reader.onload = async (e) => {
        if (e.target?.result) {
            emit('file-added', e.target.result as string);
            uploaded.value = true;
            fileName.value = file.name;
        }
    };

    reader.readAsText(file);
};
</script>
